<section class="contact-page bb-page">
  <div class="container mt-4 bb-page-shell">
    <div class="contact-wrapper bb-card bb-p-20">

      <!-- Info Side -->
      <div class="infoContainer bb-card bb-p-20">
        <span class="contact-badge bb-eyebrow">{{ 'Blue Box' | transloco }}</span>

        <h3 class="bb-page-title">{{ "Contact Us" | transloco }}</h3>

        <p class="contact-desc bb-page-subtitle">
          {{ 'تواصل معانا في أي وقت عن طريق الواتساب أو السوشيال ميديا.' | transloco }}
        </p>

        <div class="contact-links bb-grid bb-gap-12 bb-mt-16">
          <a
            *ngFor="let item of contactLinks"
            class="contact-card bb-card bb-flex bb-items-center bb-justify-between bb-gap-12 bb-p-16"
            [href]="item.url"
            [attr.target]="item.external ? '_blank' : null"
            rel="noopener"
          >
            <div class="contact-icon bb-client-action-btn bb-flex bb-items-center bb-justify-center bb-rounded-md">
              <img
                *ngIf="item.icon"
                [src]="item.icon"
                [alt]="item.label"
                class="socialImg"
              />

              <span *ngIf="!item.icon">{{ item.fallbackIcon }}</span>
            </div>

            <div class="contact-text bb-text-stack bb-w-100">
              <small class="bb-text-muted bb-font-bold">{{ item.label }}</small>
              <strong class="bb-text-navy bb-font-bold">{{ item.value }}</strong>
            </div>

            <span class="contact-arrow bb-text-blue bb-font-bold">↗</span>
          </a>
        </div>
      </div>



    </div>
  </div>
</section>